import { Component, ChangeDetectionStrategy } from '@angular/core';
import {environment} from "../../../../../environment";

@Component({
    selector: 'app-maintenance',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './maintenance.component.html'
})
export class MaintenanceComponent {

  protected readonly environment = environment;
}
